import { message } from 'antd';
import nanoid from 'nanoid';
// eslint-disable-next-line
import router from 'umi/router';
import moment from 'moment';
import {
  add,
  update,
  fetchQuestionnaire,
  fetchReceiptTempList,
  saveDraft
} from '../../../../services/notice/create';
import { queryOutboxDetail } from "../../../../services/notice/detail";
import { getComposeUrl } from "../../../../utils/common";


// 设置加载属性
const setSpinProps = ({ put, spinning = false, tip = '' }) => {
  return put({
    type: 'save',
    payload: {
      spinProps: {
        spinning,
        tip,
      },
    },
  });
};

const initState = () => {
  return {
    activeKey: '1',
    type: 'create',
    id: null,
    publishModalVisible: false,
    formData: {
      message: '', // 通知内容
      isSetTimer: 0, // 是否定时发送
      annexGroupId: '',
      fileCount: 0,
      receiptStatus: 0, // 是否选择回执单
      receiptQuestions: null,
      receiptTemplateId: '',
      receiptTitle: '',
      receiptContent: '',
      senderName: '', // 发送人署名
      senderType: 'dept',
      timer: moment(new Date()).add(2, 'hours'), // 定时发送时间
      title: '', // 通知标题
      /**
       * 附件信息列表
       * format    string  附件格式
       * name    string  文件名
       * size    number  文件大小
       * url   string   url地址
       */
      fileList: [],
      receiveUserTemplate: '', // 选人组件模板id
      btnStatus: true, // 是否可以禁用
      isCounty: 1, // 是否为区县，0=否，1=是
      subContent: '', // message 的精简，20个字符
      senderDate: moment(new Date(), 'YYYY.MM.DD').add(2, 'hours'), // 定时发送日期
      senderTime: moment(new Date(), 'HH:mm:ss').add(2, 'hours'), // 定时发送时间
      pushSetting: 1,
      forwardFlag: 1, // 是否允许转发 0-不允许，1-允许
    },
    requiredFields: ['message', 'timer', 'title', 'receiveUserTemplate'], // 必填字段数组
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
    questionList: [], // 问卷收集列表
  };
};

export default {
  namespace: 'noticeCreate',

  state: initState(),

  effects: {
    *fetchDetails({ payload }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const response = yield call(queryOutboxDetail, payload);

        const {
          annexList,
          sendTime,
          receiveUserTemplate,
          receiverRule,
          isSetTimer,
          receiptStatus,
          receiptTemplateId,
          question,
          receiptQuestions,
          ...otherProps
        } = response;

        const { type } = payload;

        // 转换时间
        let newTimer = (type === 'reEdit' || sendTime === null) ? new Date() : sendTime;
        if ((type === 'reEdit' || sendTime === null)) {
          newTimer = moment(new Date()).add(2, 'hours')
        } else {
          newTimer = moment(new Date(newTimer));
        }
        const senderDate = moment(newTimer, 'YYYY.MM.DD');
        const senderTime = moment(newTimer, 'HH:mm:ss');

        // 转换附件格式列表
        const fileList = (annexList || []).map(file => {
          const { name, size, url } = file;

          return {
            uid: nanoid(),
            type: 'edit',
            name,
            status: 'done',
            response: undefined,
            size,
            url,
          };
        });

        const { formData: initFormData } = initState();
        const formData = Object.assign({}, initFormData, {
          ...otherProps,
          fileList,
          isSetTimer: (type === 'reEdit' || type === 'create') ? initFormData.isSetTimer : isSetTimer,
          receiptStatus: receiptStatus ? 1 : 0,
          receiptTemplateId,
          timer: newTimer,
          senderDate,
          senderTime,
          receiveUserTemplate: receiveUserTemplate || receiverRule || '',
          btnStatus: false,
          receiptQuestions: typeof receiptQuestions === 'string' ? JSON.parse(receiptQuestions) : receiptQuestions,
          question,
        });

        yield put({
          type: 'saveFormData', // 在saveFormData方法中修改btnStatus状态
          payload: {
            formData,
          },
        });

        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
            type: 'edit',
          },
        });
        return Promise.resolve(formData);

      } catch (error) {
        yield setSpinProps({ put });
        message.error(error.msg || '网络错误，请重试');
        return Promise.reject();
      }
    },
    *getQuestionnaire({ payload }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const questionList = yield call(fetchQuestionnaire, payload);

        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
            questionList,
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
        message.error(error && error.msg || '网络错误，请重试');
      }
    },
    *getReceiptTempList({ payload }, { call, put }) {
      try {
        const receiptTempList = yield call(fetchReceiptTempList, payload);
        const {templateId = 0, title, content, question} = receiptTempList.content[0];

        yield put({
          type: 'saveFormData', // 在saveFormData方法中修改btnStatus状态
          payload: {
            receiptTitle : title,
            receiptTemplateId : templateId,
            receiptContent : content,
            receiptQuestions : question,
          },
        });

        yield put({
          type: 'save',
          payload: {
            receiptTempList,
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
        message.error(error.msg || '网络错误，请重试');
      }
    },
    *fetchSaveDraft({ payload }, { call, put }) {
      try {
        const data = yield call(saveDraft, payload);

        return Promise.resolve(data);

      } catch (error) {
        message.error(error.msg || '网络错误，请重试');
        return Promise.reject();
      }
    },
    *fetchSubmit({ payload }, { call, put }) {
      try {
        const { timer, type, isSetTimer, messageType } = payload;

        let timerStamp;

        // 定时发送状态
        if(isSetTimer !== 0 && !(messageType === 'personalize' && type === 'edit')) {
          timerStamp = timer.valueOf();

          if (timer < moment()) {
            message.error('请勿选择之前的时间，重新选择定时发送时间');
            return;
          }
          if (!(timer instanceof moment)) {
            message.error('日期格式有误，请重新修改日期');
            return;
          }
        }

        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const params = {
          ...payload,
          timer: timerStamp,
          senderTime: timer,
        };

        if (type === 'edit') {

          yield call(update, params);

        } else {

          yield call(add, params);

        }

        message.success(isSetTimer !== 0 ? '保存成功' : '发布成功');

        router.push(getComposeUrl(`/notice/${messageType === 'personalize' ? 'personalize' : 'outbox'}`));

        yield put({
          type: 'reset',
        });
      } catch (error) {
        yield setSpinProps({ put });
        message.error(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    // 保存表单数据
    saveFormData(state, { payload }) {
      const { formData, requiredFields } = state;
      const { formData: newFormData = {}, ...otherProps } = payload;

      const data = Object.assign({}, { ...formData, ...newFormData, ...payload });
      const { isSetTimer, senderDate, senderTime, receiptStatus } = data;
      let isHasNullKey = false;

      // 遍历查找有否有必填项未填
      for (let index = 0, len = requiredFields.length; index < len; index += 1) {
        const key = requiredFields[index];
        const element = data[key];

        if (
          (!element || (typeof element === 'string' && element.replace(/^\s+|\s+$/g, '').length === 0)) ||
          element.length === 0
        ) {
          isHasNullKey = true;
          break;
        }

        // 判断是否有定时发送功能
        if (key === 'timer' && isSetTimer === 1 && senderDate === null && senderTime === null) {
          isHasNullKey = true;
          break;
        }

        // // 回执是否为空
        // if (receiptStatus === 1 && (!data.receiptQuestions || !data.receiptTitle)) {
        //   isHasNullKey = true;
        //   break;
        // }
      }

      // 判断按钮可点击状态
      data.btnStatus = isHasNullKey;

      // 当回执模版为否（0）时，将回执模版中的内容清空
      // if (receiptStatus === 0) {
      //   data.receiptTitle = '';
      //   data.receiptTemplateId = '';
      //   data.receiptContent = '';
      //   data.receiptQuestions = null;
      // }

      // console.log('saveFormData',data)

      return {
        ...state,
        ...otherProps,
        formData: data,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
